import {
    useDeleteUserMutation,
    useCreateUserMutation,
    useUpdateUserMutation,
    useGetUsersMutation
} from '@services/core/user/user.endpoints';
import { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

export const useUsersPageVM = () => {
    const [isArchived, setIsArchived] = useState<boolean>(false);
    const [needReload, setNeedReload] = useState<boolean>();
    const MySwal = withReactContent(Swal);

    const [
        updateUser,
        {
            isSuccess: isUpdateUserSuccess,
        }
    ] = useUpdateUserMutation();

    const [
        createUser,
        {
            isSuccess: isCreateUserSuccess,
        }
    ] = useCreateUserMutation();

    const [
        deleteUser,
        {
            isSuccess: isDeleteUserSuccess,
        }
    ] = useDeleteUserMutation();

    const handleDeleteUser = async (id: string) => {
        MySwal.fire({
            title:'Êtes-vous sûr de vouloir supprimer cet utilisateur ?',
            icon: 'warning',
            showCancelButton: true,
            iconColor: '#01539D',
            confirmButtonColor: '#01539D',
            confirmButtonText: 'Supprimer',
            cancelButtonColor: '#FF5F46',
            cancelButtonText: 'Annuler'
        }).then(async (result) => {
            if (result.isConfirmed) {
                await deleteUser({ id: String(id) });
            }
        });
    };

    useEffect(() => {
        if(isCreateUserSuccess || isUpdateUserSuccess || isDeleteUserSuccess) {
            setNeedReload((prev) => !prev);
        }
    }, [isCreateUserSuccess, isUpdateUserSuccess, isDeleteUserSuccess]);


    return {
        useGetUsersMutation,
        isArchived,
        needReload,
        setIsArchived,
        createUser,
        updateUser,
        handleDeleteUser,
        MySwal
    };
};
